import { createContext, useContext, useEffect } from "react";
import { DEFAULT_ZONE } from "@/lib/zones";

const ZoneContext = createContext(DEFAULT_ZONE);

export function ZoneProvider({ zone, children }) {
  useEffect(() => {
    if (zone) {
      document.title = `${zone.tagline} · SOS Serrurier Express`;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", zone.metaDesc);
    }
  }, [zone]);

  return <ZoneContext.Provider value={zone || DEFAULT_ZONE}>{children}</ZoneContext.Provider>;
}

export function useZone() {
  return useContext(ZoneContext);
}
